import {
  getIsConnected,
  getIsMinimize,
  getOnCall,
  getSelectedTab,
  getState,
  getDynamic,
  getUserBalance
} from './globalState.selector';

import {
  getInfo,
  getCallList,
  getMonitorState,
  getCallCustomerNumber,
  getCallCustomerName,
  getCallStartTime,
  getCallCurrentTime
} from './call.selector';

import {
  getAgentList,
  getFilter,
  getStateList,
  getQueue,
  getLiveDynamic,
  getSingleAgentList,
  getSingleFilter,
  getSingleStateList,
  getSingleQueue
} from './livemonitor.selector';

import { getRecentCallList, getTeam } from './online.selector';

import { getTeamList, getSelectedTeam } from './profile.selector';

export const globalStateSelector = {
  getIsConnected: state => getIsConnected(state),
  getIsMinimize: state => getIsMinimize(state),
  getOnCall: state => getOnCall(state),
  getSelectedTab: state => getSelectedTab(state),
  getState: state => getState(state),
  getInfo: state => getInfo(state),
  getCallList: state => getCallList(state),
  getRecentCallList: state => getRecentCallList(state),
  getTeam: state => getTeam(state),
  getTeamList: state => getTeamList(state),
  getSelectedTeam: state => getSelectedTeam(state),
  getMonitorState: state => getMonitorState(state),
  getCallCustomerNumber: state => getCallCustomerNumber(state),
  getCallCustomerName: state => getCallCustomerName(state),
  getCallStartTime: state => getCallStartTime(state),
  getCallCurrentTime: state => getCallCurrentTime(state),
  getDynamic: (state, options) => getDynamic(state, options),
  getUserBalance: (state, options) => getUserBalance(state)
};

export const livemonitorSelector = {
  getAgentList: (state, options) => getAgentList(state, options),
  getFilter: (state, options) => getFilter(state, options),
  getStateList: (state, options) => getStateList(state, options),
  getQueue: (state, options) => getQueue(state, options),
  getLiveDynamic: (state, options) => getLiveDynamic(state, options),
  getSingleAgentList: (state, options) => getSingleAgentList(state, options),
  getSingleFilter: (state, options) => getSingleFilter(state, options),
  getSingleStateList: (state, options) => getSingleStateList(state, options),
  getSingleQueue: (state, options) => getSingleQueue(state, options),
}
// errorReducer
// globalStateReducer
// onlineStateReducer
// callStateReducer
// profileStateReducer



// WEBPACK FOOTER //
// ./src/store/selector/index.js